import React from 'react';
import { Input as CInput } from '@chakra-ui/react';

const Input = ({ ...props }) => {
  return <CInput variant={'unstyled'} type="text" {...props} />;
};

export default Input;
